import { Script } from "gatsby"

import { Box, Typography } from "@mui/material"

import { Link, SvgIcon, type iconKeys, type FC } from ".."
import type { LinkType } from "../../graphql/types"

export type ArticleShareProps = {
  blogLink?: LinkType & { icon?: string } // { title: blog title, uri: blog uri }
  title?: string // Article title / Author name
  type?: "article" | "author"
}

/** A sub-component for the article share link */
const ArticleShareLinks: FC<ArticleShareProps> = ({ blogLink, title, type = "article" }) => (
  <Box
    display="grid"
    gridTemplateColumns={{ xs: "1fr", md: "repeat(2, 1fr)" }}
    borderRadius={1.5}
    sx={{ border: (theme) => `1px solid ${theme.palette["neutral.200"].main}` }}
  >
    <Box
      display="flex"
      alignItems="center"
      justifyContent="center"
      gap={3}
      py={{ xs: 4, md: 15 }}
      position="relative"
      sx={(theme) => ({
        "borderRight": { md: `1px solid ${theme.palette["neutral.200"].main}` },
        "borderBottom": { xs: `1px solid ${theme.palette["neutral.200"].main}`, md: "0" },
        "transition": theme.transitions.create(["background-color"]),

        "&:hover": {
          bgcolor: theme.palette["tertiary.200"].main,
        },
      })}
    >
      {blogLink && (
        <>
          <SvgIcon variant={(blogLink.icon as iconKeys) ?? "journeys"} size={18} />
          <Typography variant="link.xs">{blogLink.title}</Typography>
          <Link
            type="overlay"
            variant="link.xs"
            target={undefined}
            rel={undefined}
            href={blogLink.uri}
            aria-label="Read the blog"
          />
        </>
      )}
    </Box>
    <Box
      className="a2a_kit"
      display="flex"
      alignItems="center"
      justifyContent="center"
      gap={3}
      position="relative"
      py={{ xs: 4, md: 15 }}
      sx={(theme) => ({
        "transition": theme.transitions.create(["background-color"]),

        "&:hover": {
          bgcolor: theme.palette["tertiary.200"].main,
        },
      })}
    >
      <SvgIcon variant="share" size={16} />
      <Typography variant="link.xs">
        {type === "article" ? "Share This Article" : "Share This Author"}
      </Typography>
      <Link
        type="overlay"
        variant="link.xs"
        target={undefined}
        rel={undefined}
        href="https://www.addtoany.com/share"
        className="a2a_dd"
        {...(title && {
          "data-a2a-title": `Check out this ${type}: ${title}`,
        })}
        sx={{
          opacity: 0,
        }}
      />
    </Box>
    <Script async src="https://static.addtoany.com/menu/page.js" />
  </Box>
)

export default ArticleShareLinks
